<div class="ifa-list-page">
  <div class="conatiner-page-header">Investor List</div>
  <div class="ifa-list-tag-action align-h">
    <div class="form-group stretch margin-bottom-0">
      <mat-form-field>
        <input
          matInput
          type="text"
          placeholder="Search by name"
          [(ngModel)]="searchText"
          (input)="reset(searchText)"
        />
      </mat-form-field>
    </div>
    <a mat-button (click)="onChangeSearchInput(searchText)">Search</a>
    <div class="stretch text-right">
    </div>
  </div>

  <!--IFA LIST CONTAINER-->
  <app-investor-list-container [investorList]="investorList" (refersh)="onInvestorRefresh()" ></app-investor-list-container>
  <div class="no-data" *ngIf="investorList?.length === 0 ">No data found!!!</div>
  <mat-paginator [length]="totalRecords" 
                 [pageSize]="pageSize" 
                 [pageSizeOptions]="pageSizeOptions" 
                 (page)="onPageChange($event)">
  </mat-paginator>
</div>
